<div
  class="column-manage-menu"
  [ngClass]="{'widget-menu-styles': widgetMode}"
  appClickOutsideComponent
  (clickOutside)="closeMenuFromOutside()"
  role="dialog"
  aria-labelledby="manage-columns-title">
  <!-- Header -->
  <div class="menu-header">
    <nb-icon icon="layout-columns" pack="icomoon" class="icon main-icon"></nb-icon>
    <p id="manage-columns-title" [ngClass]="{'details': detailsLayout, 'with-warning': warning}">{{ 'view_translations.columns_manage' | translate }}</p>
    <p class="desc" [ngClass]="{'active': warning}" *ngIf="warning" role="alert">{{ 'view_translations.table_scroll_warning' | translate }}</p>
    <div
      [ngClass]="{'disabled': isResetDisabled}"
      class="basket-wrapper"
      (click)="resetFilters()"
      role="button"
      [attr.aria-disabled]="isResetDisabled"
      [attr.aria-label]="'view_translations.reset_filters' | translate">
      <nb-icon icon="basket" pack="icomoon" class="icon basket"></nb-icon>
    </div>
  </div>

  <!-- Options -->
  <div class="display-options">
    <div *ngFor="let option of tableColumns; trackBy: trackBySubcategory">
      <div class="option" *ngIf="option.results.length">
        <p class="title">{{ 'view_translations.' + option.subcategory | translate }}</p>
        <div class="filter-elements">
          <div class="element" *ngFor="let result of option.results; trackBy: trackByColumnId">
            <app-global-checkbox
              *ngIf="!(!detailsLayout && result.onlyDetailsVisible)"
              class="w-100"
              [required]="false"
              [checkBoxIcon]="result.icon"
              [checkBoxSize]="'10px'"
              [text]="result.text"
              [checked]="result.checked"
              (emitChange)="onCheckboxSelect(result, option.subcategory)"
              [disabled]="false"
              [uncheckedGray]="true"
              [fontSize]="'13px'"
              [size]="'30px'"
              [fontWeight]="'500'">
            </app-global-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="menu-footer">
    <app-primary-button [buttonText]="'apply_filter'" [icon]="''" [height]="40" [background]="'orange'" [fontSize]="12" (emitAction)="applyFilters()">
    </app-primary-button>
    <button class="btn cancel" (click)="closeMenuHandler()" type="button" aria-label="Cancel">{{ 'view_translations.cancel' | translate }}</button>
  </div>
</div>
<button class="btn close-button d-xl-none">
  <nb-icon class="cross-icon" icon="cross" pack="icomoon"></nb-icon>
</button>
